'use client'

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';
import QuickBuyCard from '../../components/organisms/quickBuyCard'
import { useLocale } from 'next-intl';
import Link from 'next/link';
import ShiberseLoader from '../Loader/loader';
import { useState } from 'react';

const BuyYourLand = () => {
  const t = useTranslations('BuyYourLand');
  const currentLocale = useLocale();
  const [isMapPageLoading, setIsMapPageLoading] = useState(false);

  const handleLinkClick = () => {
    setIsMapPageLoading(true);
  };

  return (
    <Section
      id="buyyourland"
      backgroundImage="/images/buy_your_land.avif"
      className="relative flex flex-col min-h-screen items-center justify-center"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Top gradient */}
      <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

      {/* Bottom gradient */}
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

      <div className="relative flex flex-col items-center text-center space-y-4 mt-44 md:mt-32">
        <h2 className="text-4xl font-bold leading-none md:text-5xl font-sora text-white uppercase">
          {t('title')}
        </h2>
        <p className="m-auto w-[100%] text-white xs:text-center sm:text-center lg:text-left sm:text-center xs:text-center text-lg font-normal leading-tight sm:ml-4 xs:ml-4 lg:ml-14 font-quicksand">
          {t('sub-title')}
          <br />
          {t('description')}
        </p>
      </div>

      <div className="relative flex flex-col items-center space-y-16 mt-8 pb-64">
        {isMapPageLoading ? <ShiberseLoader /> : (
          <Link
            href={`/${currentLocale}/map`}
            className="xs:w-[100%] sm:w-[100%] md:w-[100%] lg:w-[100%] w-[100%]  flex items-center justify-center rounded-full border border-[#F17E0E] bg-[#F38F2E] px-20 py-3 text-center text-sm font-medium text-white transition-background-color duration-300"
            onClick={handleLinkClick}
          >
            {t('view-map-btn')}
            <span className="ml-2">→</span>
          </Link>
        )}
        <div>
          <QuickBuyCard />
        </div>
      </div>
    </Section>
  );
};

export default BuyYourLand;